import { ModuleWithProviders, NgModule } from '@angular/core';
import { I2gNgTrackingBuilder } from './i2g-ng-tracking.builder';
import { I2gNgTrackingActionBuilder } from './i2g-ng-tracking-action.builder';
import { I2gTrackableDirective } from './directives/trackable.directive';
import { I2gNgUtilsModule } from 'i2g-ng-utils';

@NgModule({
  imports: [I2gNgUtilsModule],
  declarations: [I2gTrackableDirective],
  exports: [I2gTrackableDirective],
  providers: [I2gNgTrackingBuilder],
})
export class I2gNgTrackingModule {
  static forRoot(): ModuleWithProviders<I2gNgTrackingModule> {
    return {
      ngModule: I2gNgTrackingModule,
      providers: [I2gNgTrackingActionBuilder],
    };
  }
}
